import { BlockViewExtension, FlavourExtension } from '@blocksuite/std';
import type { ExtensionType } from '@blocksuite/store';
import { literal } from 'lit/static-html.js';

import { ListBlockAdapterExtensions } from './adapters/extension.js';
import { ListKeymapExtension, ListTextKeymapExtension } from './list-keymap.js';

export const ListBlockSpec: ExtensionType[] = [
  FlavourExtension('hive:list'),
  BlockViewExtension('hive:list', literal`hive-list`),
  ListKeymapExtension,
  ListTextKeymapExtension,
  ListBlockAdapterExtensions,
].flat();
